import {
    ITextBetLineNumberConfig,
    TextBetLineNumber
} from "@nolimitcity/slot-game/bin/game/betline/number/TextBetLineNumber";

export class RETextBetLineNumber extends TextBetLineNumber{
    constructor(index: number, config: ITextBetLineNumberConfig) {
        super(index, config);
    }

    /**
     * Override draw function from parent class to comment line number draw code for this game.
     * @param config
     */
    protected draw(config: ITextBetLineNumberConfig): void {
        //Code commented to prevent line numbers to draw.
    }

    protected showMouseOver(): void { }

    protected showMouseOut(): void { }

    protected showWin(): void { }

    protected showNormal(): void { }
}